export default __webpack_public_path__ + "static/media/learn_basic_button_level.521a64c5.png";